/**
 * @desc Snowmaking fanguns state actions, mutations and default state values
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "fanguns",
    layerTitle: "Fan guns",
    geojson: [],
    visibility: {
      mapView: false,
      listView: false,
      singleView: false,
      singleId: 0
    },
    loading: false,
    hasListView: true,
    legend: [
      {
        id: 1,
        name: "Polecat Manual 30",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual30Polecat.png"
      },
      {
        id: 2,
        name: "Polecat Manual 60",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual60Polecat.png"
      },
      {
        id: 3,
        name: "Polecat Auto 30",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto30Polecat.png"
      },
      {
        id: 4,
        name: "Polecat Auto 60",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60Polecat.png"
      },
      {
        id: 5,
        name: "Wizzard Manual 30",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual30Wizzard.png"
      },
      {
        id: 6,
        name: "Wizzard Manual 60",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual60Wizzard.png"
      },
      {
        id: 7,
        name: "Wizzard Auto 60",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60Wizzard.png"
      },
      {
        id: 8,
        name: "T40 Auto 30",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto30T40.png"
      },
      {
        id: 9,
        name: "HKD Fan",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60HKD.png"
      },
      {
        id: 10,
        name: "Auto 60 Tower",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/AutoTWR60.png"
      }
    ]
  }
};
